export default __webpack_public_path__ + "static/media/section1-bg3-h5.bffa9652.png";